import { config, gameState } from '@js/state';

var attempts = 0;
var hintOn = false;

var finalRouteMap_Q6 = [];

var entryPoint = [0, 0];

var selectedCount_Q6 = 0;

var routeMapSet_Q6 = 1;

var newPointDistanceQ6 = 0;

var plantArrayQ6 = [[], [], [], [], [], [], []];

var plantLeftArrayQ6 = [[], [], [], [], [], [], [], [], [], []];

var leftEntrance_Q6 = new Phaser.Geom.Point(520, -200);

var leftQ6_p1 = new Phaser.Geom.Point(275, 183);
var leftQ6_p2 = new Phaser.Geom.Point(200, 215);
var leftQ6_p3 = new Phaser.Geom.Point(159, 280);
var leftQ6_p4 = new Phaser.Geom.Point(156, 373);
var leftQ6_p5 = new Phaser.Geom.Point(202, 444);
var leftQ6_p6 = new Phaser.Geom.Point(276, 495);
var leftQ6_p7 = new Phaser.Geom.Point(361, 500);
var leftQ6_p8 = new Phaser.Geom.Point(427, 455);

var leftExitWay_Q6 = new Phaser.Geom.Point(200, 900);

var leftFinalRouteMap_Q6 = [leftEntrance_Q6, leftQ6_p1, leftQ6_p2, leftQ6_p3, leftQ6_p4, leftQ6_p5, leftQ6_p6, leftQ6_p7, leftQ6_p8, leftExitWay_Q6];

var leftRouteMapSet_Q6 = 1;

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

var entrance_Q6 = new Phaser.Geom.Point(0, 0);

var exitWay_Q6 = new Phaser.Geom.Point(0, 0);

// var Q6_p1 = new Phaser.Geom.Point(757,151);
// var Q6_p2 = new Phaser.Geom.Point(956,151);
// var Q6_p3 = new Phaser.Geom.Point(757,230);
// var Q6_p4 = new Phaser.Geom.Point(956,230);
// var Q6_p5 = new Phaser.Geom.Point(757,310);
// var Q6_p6 = new Phaser.Geom.Point(956,310);
// var Q6_p7 = new Phaser.Geom.Point(757,390);
// var Q6_p8 = new Phaser.Geom.Point(956,390);
// var Q6_p9 = new Phaser.Geom.Point(757,470);
// var Q6_p10 = new Phaser.Geom.Point(956,470);

// Phaser.Math.RotateAround(startPointQ6, 963,338, Phaser.Math.DegToRad(60))

var centerQ6 = new Phaser.Geom.Point(963, 338);

var startPointQ6 = new Phaser.Geom.Point(963, 220);

// var circlePointQ6_1 = Phaser.Math.RotateAround(startPointQ6, 960.5,330.5, 36);

// var Q6_p1 = Phaser.Math.RotateAround(startPointQ6, 960.5,330.5, 0.628319);
// var Q6_p2 = Phaser.Math.RotateAround(Q6_p1, 960.5,330.5, 0.628319);
// var Q6_p3 = Phaser.Math.RotateAround(Q6_p2, 960.5,330.5, 0.628319);
// var Q6_p4 = Phaser.Math.RotateAround(Q6_p3, 960.5,330.5, 0.628319);
// var Q6_p5 = Phaser.Math.RotateAround(Q6_p4, 960.5,330.5, 0.628319);
// var Q6_p6 = Phaser.Math.RotateAround(Q6_p5, 960.5,330.5, 0.628319);
// var Q6_p7 = Phaser.Math.RotateAround(Q6_p6, 960.5,330.5, 0.628319);
// var Q6_p8 = Phaser.Math.RotateAround(Q6_p7, 960.5,330.5, 0.628319);
// var Q6_p9 = Phaser.Math.RotateAround(Q6_p8, 960.5,330.5, 0.628319);
// var Q6_p10 = Phaser.Math.RotateAround(Q6_p9, 960.5,330.5, 0.628319);

var Q6_p1 = new Phaser.Geom.Point(1065, 279);
var Q6_p2 = new Phaser.Geom.Point(1065, 279);
var Q6_p3 = new Phaser.Geom.Point(1065, 279);

// debugger

var coordinateArrayQ6 = [Q6_p1, Q6_p2, Q6_p3];

export default class GameSceneQ6 extends Phaser.Scene {
  constructor() {
    super({
      key: "GameSceneQ6",
    });
  }

  preload() {
    this.load.image("BGQ6", "assets/Q6/BGQ6.png");

    this.load.image("D_BGQ6", "assets/Q6/D_BGQ6.png");
    this.load.image("L_curbQ6", "assets/Q6/L_curbQ6.png");

    this.load.image("hitBoxQ6", "assets/Q6/hitBoxQ6.png");
    this.load.image("curbQ6", "assets/Q6/curbQ6.png");
    this.load.image("rightPlotQ6", "assets/Q6/rightPlotQ6.png");
    this.load.image("whiteBoxQ6", "assets/Q6/whiteBoxQ6.png");

    this.load.image("leftGreyBoxQ6", "assets/Q6/leftGreyBoxQ6.png");
  }

  create() {
    this.cameras.main.fadeIn(1500, 255, 255, 255);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);
    config.audio.bgaudio.play();

    config.audio.hintAlert = this.sound.add("hintAlert").setVolume(0.05);
    config.audio.hover = this.sound.add("hover").setVolume(0.05);
    config.audio.correctAnswer = this.sound.add("correctAnswer").setVolume(0.05);
    config.audio.wrongAnswer = this.sound.add("wrongAnswer").setVolume(0.05);

    config.audio.waterCan = this.sound.add("waterCan").setVolume(0.05);
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.sunShining = this.sound.add("sunShining").setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add("flowerBlossoming").setVolume(0.05);

    for (let i = 0; i < coordinateArrayQ6.length; i++) {
      Phaser.Math.RotateAround(coordinateArrayQ6[i], 963, 338, i * Phaser.Math.DegToRad(120));
    }

    this.BGQ6 = this.add.sprite(config.width / 2, config.height / 2, "D_BGQ6");

    this.progressBar = this.add.sprite(497.81, -12.89, "progressBar").setOrigin(0);

    this.correctGreen_1 = this.add.sprite(510, 17, "correctGreen").setOrigin(0).setDepth(0);
    this.correctGreen_2 = this.add.sprite(552, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_3 = this.add.sprite(594, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_4 = this.add.sprite(636, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_5 = this.add.sprite(678, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_6 = this.add.sprite(719.2, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.scoreRefresh();

    this.deselectText = this.add
      .sprite(config.width / 2, config.height / 2, "deselectText")
      .setDepth(1)
      .setVisible(false);
    this.hand = this.add.sprite(783, 179, "hand").setOrigin(0.2, 0.2).setVisible(false).setDepth(6);

    this.addWaterButton = this.add.sprite(860, 624, "addWaterButton").setInteractive({ cursor: "pointer" }).setOrigin(0);

    this.curbQ6 = this.add.sprite(692, 67, "L_curbQ6").setOrigin(0).setDepth(2);
    this.add.sprite(651, 25, "rightPlotQ6").setOrigin(0).setDepth(2);

    this.hitBoxQ6_1 = this.add.sprite(963, 338, "hitBoxQ6").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 0.669).setAlpha(0.1).setAngle(0).setDepth(2);
    this.hitBoxQ6_2 = this.add.sprite(962, 337, "hitBoxQ6").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 0.669).setAlpha(0.1).setAngle(120).setDepth(2);
    this.hitBoxQ6_3 = this.add.sprite(963, 338, "hitBoxQ6").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0, 0.669).setAlpha(0.1).setAngle(240).setDepth(2);

    // this.whiteBoxQ6_1 = this.add.sprite(960.5,330.5, "whiteBoxQ6").setOrigin(0,1).setVisible(false).setAngle(0);
    // this.whiteBoxQ6_2 = this.add.sprite(960.5,330.5, "whiteBoxQ6").setOrigin(0,1).setVisible(false).setAngle(90);
    // this.whiteBoxQ6_3 = this.add.sprite(960.5,330.5, "whiteBoxQ6").setOrigin(0,1).setVisible(false).setAngle(180);
    // this.whiteBoxQ6_4 = this.add.sprite(960.5,330.5, "whiteBoxQ6").setOrigin(0,1).setVisible(false).setAngle(270);

    this.whiteBoxQ6_1 = this.add.sprite(963, 338, "whiteBoxQ6").setOrigin(0, 0.669).setVisible(false).setAngle(0).setDepth(2);
    this.whiteBoxQ6_2 = this.add.sprite(962, 337, "whiteBoxQ6").setOrigin(0, 0.669).setVisible(false).setAngle(120).setDepth(2);
    this.whiteBoxQ6_3 = this.add.sprite(963, 338, "whiteBoxQ6").setOrigin(0, 0.669).setVisible(false).setAngle(240).setDepth(2);

    ////
    this.leftGreyBoxQ6 = this.add.sprite(89, 110, "leftGreyBoxQ6").setOrigin(0).setVisible(false);

    this.anims.create({
      key: "sunrise",
      frames: this.anims.generateFrameNames("sunAnim", {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: "sunAnim",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: "shake",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 1,
        end: 27,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 0,
        end: 0,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.Q6_ans = this.add.sprite(0, 0, "wrongPlacardAnim").setOrigin(0).setDepth(2);

    this.Q6_qn = this.add.sprite(20.14, 473.2, "qnBoard").setOrigin(0);

    this.sun = this.add.sprite(0, 0, "sunAnim").setOrigin(0).setDepth(8);
    this.leftLine = this.add.sprite(55, 547, "line").setOrigin(0);
    this.rightLine = this.add.sprite(691, 548, "line").setOrigin(0).setDepth(2);

    this.inputWindow = this.add.sprite(690, 500, "inputWindow").setOrigin(0);

    this.Q6_leftNr = this.add.text(78, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true);
    this.Q6_leftDr = this.add.text(78, 578, "12", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5);

    this.Q6_input = this.add.text(715, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true).setDepth(2);
    this.Q6_rightDr = this.add.text(715, 578, "3", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setDepth(2);

    this.can = this.add.sprite(-200, -200, "wateringCanAnim").setOrigin(0.85, 0.9).setDepth(6);
    this.add.sprite(692.22, 646.37, "grass").setOrigin(0).setDepth(2);

    ////

    // this.Q6_qn = this.add.sprite(20.14,473.2, "qnBoard").setOrigin(0);
    // this.Q6_ans = this.add.sprite(654.14,474.2, "ansBoard").setOrigin(0);

    // this.Q6_input = this.add.text(715,523, "0", {fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b",}).setOrigin(0.5,0.5);

    // this.can = this.add.sprite(-200,-200, "wateringCanAnim").setOrigin(0.85,0.9);

    this.anims.create({
      key: "floweringQ6",
      frames: this.anims.generateFrameNames("flowering4Anim", {
        start: 30,
        end: 75,
        zeroPad: 0,
        prefix: "Flower",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    // this.hitboxClickAndHoverHandle();
    // this.handleAddWaterButton();

    // var graphics = this.add.graphics();

    // graphics.fillStyle(0xff0000, 1);

    // graphics.fillCircle(Q6_p1.x, Q6_p1.y, 4);
    // graphics.fillCircle(Q6_p2.x, Q6_p2.y, 4);
    // graphics.fillCircle(Q6_p3.x, Q6_p3.y, 4);

    // graphics.fillCircle(centerQ6.x, centerQ6.y, 7);

    // graphics.fillCircle(startPointQ6.x, startPointQ6.y, 7);

    //>1

    this.hint = this.add.sprite(255, 552, "hint_1").setScale(0.8).setVisible(false).setDepth(7);

    this.closeHintButton = this.add.sprite(445, 450, "closeHint").setVisible(false).setDepth(7).setInteractive({ cursor: "pointer" });

    // this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7).setInteractive({ cursor: "pointer" });

    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7);

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idlehint",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false);

    this.handleHintButton();

    //<1

    this.waterPlantOnLeftQ6();

    // this.startQuestionQ6();
  }

  waterPlantOnLeftQ6() {
    this.time.delayedCall(
      1500,
      () => {
        this.leftGreyBoxQ6.setVisible(true);

        this.moveCanInitial(leftFinalRouteMap_Q6[0].x, leftFinalRouteMap_Q6[0].y, leftFinalRouteMap_Q6[1].x, leftFinalRouteMap_Q6[1].y);
      },
      [],
      this
    );
  }

  startQuestionQ6() {
    //>//>>>hidden_console.log("startQ6");

    this.hitboxClickAndHoverHandle();
    this.handleAddWaterButton();
  }

  moveCanInitial(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1260,
      () => {
        this.waterTheLeftPlant(0);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(leftFinalRouteMap_Q6[leftRouteMapSet_Q6-1],leftRouteMapSet_Q6-1);
      },
      [],
      this
    );

    this.time.delayedCall(
      700,
      () => {
        this.createLeftPlants(leftFinalRouteMap_Q6[leftRouteMapSet_Q6 - 1], leftRouteMapSet_Q6 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1050,
      ease: "Cubic",
      delay: 350,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 350,
      onComplete: () => {
        if (leftRouteMapSet_Q6 < leftFinalRouteMap_Q6.length - 1) {
          this.Q6_leftNr.setText(leftRouteMapSet_Q6);

          this.moveCanInitial(leftFinalRouteMap_Q6[leftRouteMapSet_Q6].x, leftFinalRouteMap_Q6[leftRouteMapSet_Q6].y, leftFinalRouteMap_Q6[leftRouteMapSet_Q6 + 1].x, leftFinalRouteMap_Q6[leftRouteMapSet_Q6 + 1].y);

          leftRouteMapSet_Q6 = leftRouteMapSet_Q6 + 1;
          //>//>>>hidden_console.log(leftRouteMapSet_Q6);
        } else {
          this.Q6_leftNr.setVisible(true);
          this.Q6_input.setVisible(true);

          this.startQuestionQ6();
        }
      },
      onCompleteScope: this,
    });
  }

  buddingToFlowering() {
    config.audio.flowerBlossoming.play();

    for (var k5 = 0; k5 < plantLeftArrayQ6.length; k5++) {
      for (var l5 = 0; l5 < plantLeftArrayQ6[k5].length; l5++) {
        plantLeftArrayQ6[k5][l5].setTexture("flowering4Anim").play("floweringQ6");

        //>//>>>hidden_console.log(l5 + " " + k5);
      }
    }

    // plantLeftArrayQ6[1][1].setTexture("flowering4Anim").play("floweringQ6");

    for (var k = 0; k < plantArrayQ6.length; k++) {
      for (var l = 0; l < plantArrayQ6[k].length; l++) {
        plantArrayQ6[k][l].setTexture("flowering4Anim").play("floweringQ6");
      }
    }

    // this.time.delayedCall(5000, () => {

    //   this.scene.stop("GameSceneQ6");
    //   this.scene.start('GameSceneQ7');

    // },[],this);

    this.changeScene();
  }

  changeScene() {
    //>//>>>hidden_console.log("ready to change scene");
    gameState.attempted = gameState.attempted + 1;

    this.tweens.add({
      targets: config.audio.bgaudio,
      volume: 0.005,
      duration: 4000,
      onComplete: () => {},
    });

    this.time.delayedCall(
      3000,
      function () {
        this.time.delayedCall(
          1000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this
        );

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            config.audio.bgaudio.stop();
            config.audio.flowerBlossoming.stop();
            config.audio.sunShining.stop();
            attempts = 0;

            this.wipeSceneQ6();

            if (gameState.score >= 5) {
              gameState.gameWin = true;
              this.scene.stop("GameSceneQ6");
              this.scene.start("EndScene");
            } else if (gameState.attempted == 9) {
              gameState.gameWin = false;
              this.scene.stop("GameSceneQ6");
              this.scene.start("EndScene");
            } else {
              this.scene.stop("GameSceneQ6");
              this.scene.start("GameSceneQ7");
            }

            this.cameras.main.fadeIn(1000, 255, 255, 255);

            // this.time.delayedCall(
            //   2000,
            //   function () {
            // this.cameras.main.fadeIn(1000, 255, 255, 255);
            //   },
            //   [],
            //   this
            // );
          },
          this
        );

        if (gameState.attempted == 10) {
          gameState.gameWin = false;
          // this.scene.stop("TutorialScene");
          this.scene.start("EndScene");
        }
      },
      [],
      this
    );
  }

  wipeSceneQ6() {
    attempts = 0;
    hintOn = false;

    finalRouteMap_Q6 = [];

    entryPoint = [0, 0];

    selectedCount_Q6 = 0;

    routeMapSet_Q6 = 1;

    newPointDistanceQ6 = 0;

    plantArrayQ6 = [[], [], [], [], [], [], [], [], [], [], []];

    plantLeftArrayQ6 = [[], [], [], [], [], [], [], [], [], []];

    // leftFinalRouteMap_Q6 = [leftEntrance_Q6,leftQ6_p1,leftExitWay_Q6];
    leftRouteMapSet_Q6 = 1;

    entrance_Q6.setTo(0, 0);

    exitWay_Q6.setTo(0, 0);

    Q6_p1.setTo(1065, 279);
    Q6_p2.setTo(1065, 279);
    Q6_p3.setTo(1065, 279);
  }

  toggleHit(hitboxname, xcode, ycode) {
    this.hideDeselect();

    if (hitboxname.alpha == 0.1) {
      hitboxname.setAlpha(1);

      this.updateRouteMap(xcode, ycode);

      selectedCount_Q6 += 1;

      this.Q6_input.setText(selectedCount_Q6);
    } else {
      hitboxname.setAlpha(0.1);

      Phaser.Utils.Array.Remove(finalRouteMap_Q6, this.getPointFromCode(xcode, ycode));

      selectedCount_Q6 -= 1;
      this.Q6_input.setText(selectedCount_Q6);
    }
  }

  updateRouteMap(xcode, ycode) {
    if (finalRouteMap_Q6.length <= 1) {
      finalRouteMap_Q6.push(this.getPointFromCode(xcode, ycode));
    } else {
      newPointDistanceQ6 = this.calculateDistance(finalRouteMap_Q6[0], this.getPointFromCode(xcode, ycode));

      //>//>>>hidden_console.log(newPointDistanceQ6);

      var routeMapLength_Q6 = finalRouteMap_Q6.length;

      for (var i = 0; i < routeMapLength_Q6 - 1; i++) {
        //>//>>>hidden_console.log(Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q6[0],finalRouteMap_Q6[i+1]));

        if (Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q6[0], finalRouteMap_Q6[i + 1]) > newPointDistanceQ6) {
          if (xcode == 0 && ycode == 0) {
            finalRouteMap_Q6.insert(i + 1, Q6_p1);
          } else if (xcode == 1 && ycode == 0) {
            finalRouteMap_Q6.insert(i + 1, Q6_p2);
          } else if (xcode == 0 && ycode == 1) {
            finalRouteMap_Q6.insert(i + 1, Q6_p3);
          }
        } else {
          if (xcode == 0 && ycode == 0) {
            finalRouteMap_Q6.push(Q6_p1);
          } else if (xcode == 1 && ycode == 0) {
            finalRouteMap_Q6.push(Q6_p2);
          } else if (xcode == 0 && ycode == 1) {
            finalRouteMap_Q6.push(Q6_p3);
          }
        }

        break;
      }
    }

    //>//>>>hidden_console.log(finalRouteMap_Q6);
  }

  getPointFromCode(xcode, ycode) {
    if (xcode == 0 && ycode == 0) {
      return Q6_p1;
    } else if (xcode == 1 && ycode == 0) {
      return Q6_p2;
    } else if (xcode == 0 && ycode == 1) {
      return Q6_p3;
    }
  }

  scoreUpdate() {
    gameState.score = gameState.score + 1;

    //>//>>>hidden_console.log("score: " + gameState.score);

    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  handleAddWaterButton() {
    this.addWaterButton.on("pointerover", () => {
      this.addWaterButton.setTexture("hover_addWaterButton");
    });
    this.addWaterButton.on("pointerout", () => {
      this.addWaterButton.setTexture("addWaterButton");
    });
    this.addWaterButton.on("pointerup", () => {
      this.removeClicking();

      if (selectedCount_Q6 == 2) {
        config.audio.correctAnswer.play();
        this.tweens.add({
          targets: this.addWaterButton,
          duration: 500,
          ease: "easeInOutSine",
          //delay: 100,
          yoyo: false,
          // x: {from:783, to:1069},
          y: { from: 624, to: 800 },
          // scale: {from:1, to:0.8},
          loop: 0,
        });

        //>2

        this.hintButton.removeInteractive();
        this.hideDeselect();

        if (hintOn == true) {
          this.hintButton.play("pop_out");
          hintOn = false;
        }

        //gameState.score = gameState.score + 1;

        //>//>>>hidden_console.log("score: " + gameState.score);

        //<2

        this.Q6_ans.setTint(0xffffff);

        this.removeClicking();

        this.scoreUpdate();

        if (finalRouteMap_Q6[0] == Q6_p1) {
          entrance_Q6.setTo(2045.5, 236.7);
        } else if (finalRouteMap_Q6[0] == Q6_p2) {
          entrance_Q6.setTo(2045.4, 413.5);
        } else if (finalRouteMap_Q6[0] == Q6_p3) {
          entrance_Q6.setTo(868.6, 900);
        }
        finalRouteMap_Q6.unshift(entrance_Q6);

        if (finalRouteMap_Q6[finalRouteMap_Q6.length - 1] == Q6_p1) {
          exitWay_Q6.setTo(2045.5, 236.7);
        } else if (finalRouteMap_Q6[finalRouteMap_Q6.length - 1] == Q6_p2) {
          exitWay_Q6.setTo(2045.4, 413.5);
        } else if (finalRouteMap_Q6[finalRouteMap_Q6.length - 1] == Q6_p3) {
          exitWay_Q6.setTo(868.6, 900);
        }

        finalRouteMap_Q6.push(exitWay_Q6);

        this.moveCan(finalRouteMap_Q6[0].x, finalRouteMap_Q6[0].y, finalRouteMap_Q6[1].x, finalRouteMap_Q6[1].y);
      } else {
        config.audio.wrongAnswer.play();

        //>3

        this.incorrectAttempt();

        this.hintButton.removeInteractive();

        //<3
        // this.Q6_ans.setTint(0xFFC2A2);

        this.Q6_ans.play("shake");

        this.inputWindow.setVisible(false);

        this.rightLine.setTexture("redLine");

        this.Q6_rightDr.setFill("#C22300");
        this.Q6_input.setFill("#C22300");

        this.time.delayedCall(
          2500,
          () => {
            this.Q6_ans.play("idle");
            this.inputWindow.setVisible(true);

            this.rightLine.setTexture("line");

            this.Q6_rightDr.setFill("#2b2b2b");
            this.Q6_input.setFill("#2b2b2b");
          },
          [],
          this
        );
      }
    });
  }

  //>4
  handleHintButton() {
    this.hintButton.on(
      "pointerup",
      function (pointer) {
        ////
        gameState.hints += 1;

        this.hintButton.setVisible(true);

        this.hintButton.play("idlehint");

        this.removeClicking();

        if (attempts == 1) {
          this.hint.setTexture("hint_1");

          this.overlay.setVisible(true).setDepth(6);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(6);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.enableClicking();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");
        this.hintButton.removeInteractive();

        hintOn = false;
      },
      this
    );
  }

  incorrectAttempt() {
    // correctAnswer = false;
    this.hintButton.setVisible(false);

    // ////

    attempts += 1;

    if (attempts == 1 || attempts == 2) {
      this.showDeselect();
    } else {
      this.addWaterButton.setTexture("disable_addWaterButton");
    }
    //>//>>>hidden_console.log(attempts);

    this.time.delayedCall(
      1000,
      function () {
        if (attempts == 1 || attempts == 2) {
          hintOn = true;

          this.hintButton.setVisible(true);

          this.hintButton.play("pop");
          config.audio.hintAlert.play();

          this.time.delayedCall(
            1300,
            () => {
              this.enableClicking();

              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );

          this.time.delayedCall(
            500,
            function () {
              if (hintOn) {
                this.hintButton.play("breathe");
              }
            },
            [],
            this
          );
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        } else {
          this.removeClicking();
          this.changeScene();

          if (hintOn == true) {
            this.hintButton.play("pop_out");
            hintOn = false;
          }

          this.time.delayedCall(
            3300,
            function () {
              attempts = 0;
            },
            [],
            this
          );
        }
      },
      [],
      this
    );
  }

  //<4

  calculateDistance(target1, target2) {
    return Phaser.Math.Distance.BetweenPoints(target1, target2);
  }

  moveCan(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(100);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createPlants(finalRouteMap_Q6[routeMapSet_Q6 - 1], routeMapSet_Q6 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (routeMapSet_Q6 < finalRouteMap_Q6.length - 1) {
          this.moveCan(finalRouteMap_Q6[routeMapSet_Q6].x, finalRouteMap_Q6[routeMapSet_Q6].y, finalRouteMap_Q6[routeMapSet_Q6 + 1].x, finalRouteMap_Q6[routeMapSet_Q6 + 1].y);

          routeMapSet_Q6 = routeMapSet_Q6 + 1;
          //>//>>>hidden_console.log(routeMapSet_Q6);
        } else {
          config.audio.sunShining.play();

          this.tweens.add({
            targets: config.audio.sunShining,
            volume: 0.005,
            duration: 3000,
            onComplete: () => {},
          });

          this.sun.play("sunrise");

          this.time.delayedCall(
            3000,
            () => {
              this.buddingToFlowering();
              config.audio.sunShining.stop();
            },
            [],
            this
          );
        }
      },
      onCompleteScope: this,
    });
  }
  showDeselect() {
    if (selectedCount_Q6 >= 2) {
      if (!gameState.firstMistake) {
        this.deselectText.setVisible(true);

        this.hand.setVisible(true);
        this.tweens.add({
          targets: this.hand,
          duration: 500,
          ease: "easeInOutSine",
          // delay: 500,
          yoyo: true,
          // x: {from:783, to:1069},
          // y: {from:179, to:640},
          scale: { from: 1, to: 0.8 },
          loop: -1,
        });

        this.hand.setPosition(finalRouteMap_Q6[0].x, finalRouteMap_Q6[0].y);
      }

      gameState.firstMistake = true;
    }
  }

  hideDeselect() {
    this.deselectText.setVisible(false);
    this.hand.setVisible(false);
  }

  hitboxClickAndHoverHandle() {
    this.BGQ6.setTexture("BGQ6");
    this.curbQ6.setTexture("curbQ6");
    this.hitBoxQ6_1.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ6_1, 0, 0);
      },
      this
    );
    this.hitBoxQ6_2.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ6_2, 1, 0);
      },
      this
    );
    this.hitBoxQ6_3.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ6_3, 0, 1);
      },
      this
    );

    this.hitBoxQ6_1.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ6(1);
      },
      this
    );
    this.hitBoxQ6_2.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ6(2);
      },
      this
    );
    this.hitBoxQ6_3.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ6(3);
      },
      this
    );

    this.hitBoxQ6_1.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ6();
      },
      this
    );
    this.hitBoxQ6_2.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ6();
      },
      this
    );
    this.hitBoxQ6_3.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ6();
      },
      this
    );
  }

  enableClicking() {
    this.hitBoxQ6_1.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ6_2.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ6_3.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.addWaterButton.setInteractive({ cursor: "pointer" });
    this.addWaterButton.setTexture("addWaterButton");
  }

  ///<5

  removeClicking() {
    this.hitBoxQ6_1.removeInteractive();
    this.hitBoxQ6_2.removeInteractive();
    this.hitBoxQ6_3.removeInteractive();

    this.addWaterButton.removeInteractive();
    if (attempts == 0 || attempts == 1) {
      this.addWaterButton.setTexture("addWaterButton");
    }
  }

  scoreRefresh() {
    //>//>>>hidden_console.log("score: " + gameState.score);
    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  showWhiteBoxQ6(position) {
    config.audio.hover.play();

    this.removeWhiteBoxQ6();
    if (position == 1) {
      this.whiteBoxQ6_1.setVisible(true);
    }
    if (position == 2) {
      this.whiteBoxQ6_2.setVisible(true);
    }
    if (position == 3) {
      this.whiteBoxQ6_3.setVisible(true);
    }
  }

  createPlants(selectedPoint, plantSelectionCode) {
    plantArrayQ6[plantSelectionCode][0] = this.add
      .sprite(selectedPoint.x - 50, selectedPoint.y - 60, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
    plantArrayQ6[plantSelectionCode][1] = this.add
      .sprite(selectedPoint.x + 50, selectedPoint.y - 60, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);

    plantArrayQ6[plantSelectionCode][2] = this.add
      .sprite(selectedPoint.x - 50, selectedPoint.y + 30, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
    plantArrayQ6[plantSelectionCode][3] = this.add
      .sprite(selectedPoint.x + 50, selectedPoint.y + 30, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);

    plantArrayQ6[plantSelectionCode][4] = this.add
      .sprite(selectedPoint.x, selectedPoint.y - 30, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
  }

  createLeftPlants(selectedPoint, plantSelectionCode) {
    // plantLeftArrayQ6[plantSelectionCode][0] = this.add.sprite(selectedPoint.x,selectedPoint.y,"playSwayAnim").setScale(0.3).play("plantbudding");
    // plantLeftArrayQ6[plantSelectionCode][1] = this.add.sprite(selectedPoint.x,selectedPoint.y,"playSwayAnim").setScale(0.3).play("plantbudding");

    // plantLeftArrayQ6[plantSelectionCode][2] = this.add.sprite(selectedPoint.x,selectedPoint.y,"playSwayAnim").setScale(0.3).play("plantbudding");
    // plantLeftArrayQ6[plantSelectionCode][3] = this.add.sprite(selectedPoint.x,selectedPoint.y,"playSwayAnim").setScale(0.3).play("plantbudding");

    if (selectedPoint == leftQ6_p1) {
      plantLeftArrayQ6[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ6[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 25, selectedPoint.y + 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else if (selectedPoint == leftQ6_p2) {
      plantLeftArrayQ6[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ6[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y + 30, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else if (selectedPoint == leftQ6_p3) {
      plantLeftArrayQ6[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 25, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ6[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 45, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else if (selectedPoint == leftQ6_p4) {
      plantLeftArrayQ6[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 5, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ6[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y - 30, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else if (selectedPoint == leftQ6_p5) {
      plantLeftArrayQ6[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 25, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ6[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 30, selectedPoint.y - 60, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else if (selectedPoint == leftQ6_p6) {
      plantLeftArrayQ6[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ6[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else if (selectedPoint == leftQ6_p7) {
      plantLeftArrayQ6[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ6[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x, selectedPoint.y - 80, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else if (selectedPoint == leftQ6_p8) {
      plantLeftArrayQ6[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 50, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ6[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y - 15, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    }
  }

  removeWhiteBoxQ6() {
    this.whiteBoxQ6_1.setVisible(false);
    this.whiteBoxQ6_2.setVisible(false);
    this.whiteBoxQ6_3.setVisible(false);
  }

  waterThePlant(flowingtime) {
    if (routeMapSet_Q6 <= selectedCount_Q6 || leftRouteMapSet_Q6 < leftFinalRouteMap_Q6.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");
            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  waterTheLeftPlant(flowingtime) {
    if (routeMapSet_Q6 <= selectedCount_Q6 || leftRouteMapSet_Q6 < leftFinalRouteMap_Q6.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      700,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");
            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
